<mat-card>
  <mat-card-title>
    {{ passedMeasureName }}
  </mat-card-title>
    <canvas id="myChart"></canvas>
</mat-card>
